import axios from 'axios';

export default {
  fetchProductItems(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+'/api/latest/admin/product-items', {params})
      .then(res => res && res.data);
  },
  getProductItem(productItemId){
      return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+'/api/latest/admin/product-items/'+productItemId)
      .then(res => res && res.data);

  }
}
